module.exports = __webpack_public_path__ + "bf610c608b8d995219b7f781c4551301.png";